<template>

  <v-flex
    v-show='field.type!=="hidden"'
    v-if='visible'
    xs12
    :sm6="!field.full"
    :md2="field.mini"
    :md3="field.slim"
    :md4="field.small"
    :md10="field.big"
    :md12="field.full"
    :sm12="field.full"
    :md6="!field.small && !field.full && !field.big"
    :class="select && 'pa-0 ma-0'"

  >

    <v-alert type='warning' v-if="field.type === 'alert' && typeof value === 'string'">{{ value }}</v-alert>

    <v-text-field
      :data-type="field.type"
      :data-cy="field.value"
      v-if="field.type === 'text' || field.type === 'number' || !field.type"
      :value="value"
      :rules="!readonly ? rules : []"
      :label="field.text"
      permanent-hint
      :hint='typeof field.hint === "function" ? field.hint(item) : undefined'
      :readonly="readonly"
      :disabled="readonly"
      @input="updateValue"
    />

    <v-select
      v-if="field.type === 'list'"
      :data-type="field.type"
      :data-cy="field.value"
      :disabled="readonly"
      :value="value"
      :items="computedList()"
      :rules="!readonly ? rules : []"
      :label="field.text"
      :multiple="field.multiple"
      :chips="field.multiple"
      deletable-chips
      clearable
      md4
      @input="updateValue"
    />

    <v-autocomplete    
      v-if="field.type === 'autocomplete'"
      :data-type="field.type"
      :data-cy="field.value"
      :disabled="readonly"
      :value="value"
      :items="items"
      :rules="!readonly ? rules : []"
      :multiple="field.multiple"
      :chips="field.multiple"
      :small-chips="field.multiple"
      deletable-chips
      no-filter
      :loading="loading"
      :label="!select ? field.text : ''"
      :search-input.sync='search'
      :placeholder="field.placeholder || `Choose a ${field.text}...`"
      :class="select ? 'ma-0 pa-0' : ''"
      color="green"
      hide-no-data
      :item-text="field.title || 'name'"
      :item-value="field.id || 'id'"
      :prepend-icon="!select ? 'mdi-database-search' : ''"
      md4
      clearable
      @change="updateValue">
      <template v-slot:item="{ item }">
        <v-list-item-content two-line>
          <v-list-item-title v-text="autocompleteTitle(item)" />
          <v-list-item-subtitle v-text="autocompleteSubtitle(item)" />
        </v-list-item-content>
      </template>
    </v-autocomplete>

    <v-combobox
      v-if="field.type === 'combobox'"
      :data-type="field.type"
      :data-cy="field.value"      
      :disabled="readonly"
      :multiple="field.multiple"
      :chips="field.multiple"
      :small-chips="field.multiple"
      deletable-chips
      :value="value"
      :items="!field.manual ? items : []"
      :rules="!readonly ? rules : []"
      :loading="loading"
      :return-object="false"
      :item-text="field.text || 'name'"
      :item-value="field.id || 'id'"
      :label="field.text"
      :placeholder="`Choose or add a ${field.text}...`"
      color="green"
      hide-no-data
      :prepend-icon="!field.manual ? 'mdi-database-plus' : ''"
      md4
      clearable
      @change="updateValue">
      <template v-slot:item="{ item }">
        <v-list-item-content two-line>
          <v-list-item-title v-text="autocompleteTitle(item)" />
          <v-list-item-subtitle v-text="autocompleteSubtitle(item)" />
        </v-list-item-content>
      </template>
    </v-combobox>


    <v-file-input
      v-if="field.type === 'file'"
      :data-type="field.type"
      :data-cy="field.value"
      @change='updateValue'
      :hint='field.hint'
      persistent-hint
      :disabled='readonly'
      :accept="field.accept || 'application/pdf'"
      :label="field.text"
      :rules='!readonly ? rules : []'
    />

    <v-checkbox
      v-if="field.type === 'check'"
      :disabled="readonly"
      :data-type="field.type"
      :data-cy="field.value"
      :label="field.text"
      :true-value="1"
      :false-value="0"
      :input-value='value'
      full-width
      required
      @change="updateValue"
    />

    <v-switch
      v-if="field.type === 'switch'"
      :disabled="readonly"
      :label="field.text"
      :true-value="1"
      :false-value="0"
      :data-type="field.type"
      :data-cy="field.value"
      persistent-hint
      :hint='field.hint'
      :input-value='value'
      full-width
      inset
      @change="updateValue"
    />

    <v-textarea
      v-if="field.type === 'textarea'"
      :data-type="field.type"
      :data-cy="field.value"
      :value="value"
      :rows="3"
      :rules="!readonly ? rules : []"
      permanent-hint
      :hint='typeof field.hint === "function" ? field.hint(item) : undefined'      
      :label="field.text"
      :disabled="readonly"
      @input="updateValue"
    />

     <!-- issue 257 services -->
     <v-menu
      v-if="field.type === 'datetime' || field.type === 'date'"
      ref="menu_datePicked"
      v-model="menu_datePicker"
      :disabled="readonly"
      :close-on-content-click="false"
      :rules="rules"
      transition="scale-transition"
      offset-y      :id="field.value"
      max-width="290px"
      min-width="290px"
    >
    <!-- issue 257 services -->
      <!-- //issue 316 - modifica date da-a , aggiunto placeholderx -->
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :data-type="field.type"
          :data-cy="field.value"
          :value="value"
          :rules="!readonly ? rules : []"
          :label="!select ? field.text : ''"
          :class="select ? 'datafromto ma-0 pa-0' : 'datafromto'"
          :placeholder="placeholderx || field.placeholder || 'Search'"
          v-bind="attrs"
          :clearable='!readonly'
          :disabled='readonly'
          readonly
          v-on="on"
          @click:clear='dateChange()'
        />
      </template>
      <!-- //issue 316 - modifica date da-a , aggiunto placeholderx -->

      <v-date-picker
        :disabled="readonly"
        :rules="rules"
        dark
        :value='value'
        no-title
        :max="maxDate()"
        :min="minDate()"
        @input="dateChange"
      />
    </v-menu>

    <v-text-field
      v-if="field.type === 'password'"
      :data-type="field.type"
      :data-cy="field.value"
      :readonly="readonly"
      :value="value"
      :rules="!readonly ? rules : []"
      :label="field.text"
      type="password"
      autocomplete="new-password"
      @input="updateValue"
    />

  </v-flex>
</template>
<script>
/**
 * Autocomplete config example:
 * 
 */
import validators from '@/utils/validators'
import get from 'lodash/get'
import uniqBy from 'lodash/unionBy'
const { getList } = require('@/api/base_entity')

export default {
  props: {
    field: { type: Object, default: () => ({}) },
    readonly: { type: [Boolean, Number], default: false },
    select: { type: Boolean, default: false },
    value: { type: [String, Number, Boolean, File, Date, Array, Object], default: undefined },
    item: { type: Object, default: () => ({}) },
    //issue 316 - modifica date da-a , aggiunto placeholderx
    placeholderx: {type: [String], default: undefined } 
    //issue 316 - modifica date da-a , aggiunto placeholderx
  },
  data() {
    return {
      cachedItems: [],
      items: [],
      visible: false,
      search: '',
      loading: false,
      menu_datePicker: false
    }
  },
  watch: {
    search(val, oldval) {
      if (oldval) {
        this.updateAutocomplete()
      }
    }
  },
  computed: {
    autocomplete_entity() {
      return this.field.reference || this.field.value.split('_')[0]
    },
    rules() {
      if (!this.field.validators) return []
      return this.field.validators.map(v => {
        if (typeof v === 'function') {
          return () => v(this.field, this.value, this.item)
        }
        return typeof validators[v] === 'function' ? validators[v](this.field.text) : validators[v]
      })
    }
  },
  async created() {
    if (this.field.type === 'autocomplete' || this.field.type === 'combobox') {

      // cache values
      if (this.value && !this.field.manual) {
        const filters = this.field.filter ? this.field.filter(this.item, '') : {}
        const id = this.field.id || this.field.value.split('_')[1]
        filters[id] = this.value
        if (typeof this.field.list === 'function') {
          this.cachedItems = await this.field.list(this.autocomplete_entity, this.search || '', this.item).then(ret => ret.data).catch(e => console.error(e))
        } else {
          this.cachedItems = await getList(this.autocomplete_entity, filters, { rowsPerPage: 20 }).then(ret => ret.data)
        }
      }
      this.updateAutocomplete()
    }

    if (typeof this.field.render === 'function' && this.readonly) {
      this.$emit('input', this.field.render(this.item))
    }

    if (this.field.deps) {
      this.$root.$on('itemUpdated', async arg => {

        if (typeof this.field.default === 'function') {
          await this.updateDefault(arg)
        }

        if (typeof this.field.visible === 'function') {
          this.updateVisibility(arg)
        }

        if (this.field.filter || this.field.list) {
          this.$nextTick(() => {
            this.updateAutocomplete(arg)
          })
        }
      })
    }

    if (typeof this.field.default === 'function') {
      if (typeof this.value === 'undefined' || this.value === null) {
        await this.updateDefault({ field: { value: this.field.deps ? this.field.deps[0] : null } })
      }
    }

    if (typeof this.field.visible === 'function') {
      this.visible = this.field.visible(this.item, this.$store.state)
    } else if (typeof this.field.visible === 'boolean') {
      this.visible = this.field.visible
    } else {
      this.visible = true
    }

    //  should check if already evaluated
    if (this.field.default && typeof this.field.default !== 'function') {
      this.$emit('value', this.field.default)
    }
  },
  destroyed() {
    this.$root.$off('itemUpdated')
  },
  methods: {
    minDate () {
      if (this.field.min && this.field.min !== false) {
        if (this.field.min === true) {
          return new Date().toISOString()
        }
        if (typeof this.field.min === 'function') {
          return this.field.min(this.$store.state)
        }
      }
    },
    maxDate () {
      if (this.field.max && this.field.max !== false) {
        if (this.field.max === true) {
          return new Date().toISOString()
        }
        if (typeof this.field.max === 'function') {
          return this.field.max(this.$store.state)
        }
      }
    },
    computedList() {
      if (typeof this.field.list === 'function') {
        try {
          return this.field.list(this.item, this.$store.state)
        } catch (e) {
          console.error(e)
        }
      }
      return this.field.list
    },
    dateChange(v) {
      this.$emit('input', v)
      this.menu_datePicker = false
    },
    autocompleteSubtitle(item) {
      if (!this.field.subtitle) return
      if (typeof this.field.subtitle === 'string') {
        return get(item, this.field.subtitle)
      }
      return this.field.subtitle(item)
    },
    autocompleteTitle(item) {
      if (!this.field.title) return
      if (typeof this.field.title === 'string') {
        return get(item, this.field.title)
      }
      return this.field.title(item)
    },
    async updateAutocomplete(args) { // (field = null) {
      if (this.field.manual) return
      if (args !== undefined) {
        if (!this.field.deps || !this.field.deps.includes(args.field.value)) {
          return
        } else {
          this.cachedItems = []
        }
      }
      this.loading = true
      if (typeof this.field.list === 'function') {
        this.items = await this.field.list(this.autocomplete_entity, this.search || '', this.item).then(ret => ret.data).catch(e => console.error(e))
      } else {
        const filters = this.field.filter ? this.field.filter(this.item, this.search || '') : {}
        if (this.search && !filters[this.field.title] && typeof this.field.title !== 'function') {
          filters[this.field.title] = '%' + (this.search || '') + "%"
        }
        let items = await getList(this.autocomplete_entity, filters, { rowsPerPage: 200 }).then(ret => ret.data)
        if (this.cachedItems) {
          items = items.concat(this.cachedItems)
        }
        this.items = uniqBy(items, this.field.id || this.field.value.split('_')[1])
      }
      this.loading = false
    },
    updateVisibility(args) {
      if (args === undefined || !this.field.deps || !this.field.deps.includes(args.field.value)) {
        return
      }
      this.visible = this.field.visible(this.item, this.$store.state, args && args.field, args.selectedItem)
    },
    async updateDefault(args) {
      if (args === undefined || !this.field.deps || !this.field.deps.includes(args.field.value)) {
        return
      }
      const value = await this.field.default(this.item, args && args.field, args.selectedItem, this.$store.state, this.field)
      this.$emit('input', value)
      this.$root.$emit('itemUpdated', { field: this.field, selectedItem: args && args.selectedItem })
    },
    updateValue(value) {
      if (this.field.type === 'number') {
        value = Number(value)
        if (isNaN(value)) return
      }
      if (this.field.type === 'combobox' && typeof value === 'object' && !this.field.manual) {
        value = value === null ? null : get(value, this.field.id || 'id')
      }
      this.$emit('input', value)
      let selectedItem
      if (this.field.type === 'autocomplete' || this.field.type === 'combobox') {
        selectedItem = this.items?.find(item => get(item, this.field.id || 'id') === value)
        if (this.field.multiple) {
          this.cachedItems = Array.isArray(value) ? this.items.filter(item => value.includes(get(item, this.field.id || 'id'))) : []
        }
      }
      this.$nextTick(() => {
        this.$root.$emit('itemUpdated', { field: this.field, selectedItem })
        this.$emit('input:field', { field: this.field, selectedItem })
      })
    }
  }
}
</script>
